export default "/_next/static/images/service-dfa-desktop-2x-6c4d61113245bab81457c8fa80f15b93.jpg";